import React from 'react';
import { BlankLink } from '@contently/toolkit';

const StoryAlreadyClaimed = () => (
  <div>
    <h2>We’re sorry, but this story has been claimed by another contributor.</h2>
    <div>
      <BlankLink href="https://contently.net">Subscribe to The Freelancer</BlankLink>
    </div>
    <div>
      <BlankLink href="https://contently-support.zendesk.com/hc/en-us/articles/21627463987218-How-do-I-reach-out-to-my-Creative-Lead">
        Contact your Managing Editor
      </BlankLink>
    </div>
    <div>
      <BlankLink href="https://contently-support.zendesk.com/hc/en-us/articles/21627483905810-Optimizing-existing-content-for-organic-search-visibility">
        Optimize your portfolio
      </BlankLink>
    </div>
    <div>
      <BlankLink href="https://contently-support.zendesk.com">Visit our Help Center</BlankLink>
    </div>
  </div>
);

export default StoryAlreadyClaimed;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_already_claimed/story_already_claimed.jsx